export default "__VITE_ASSET__8369a7cc__"